import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import Cookies from "universal-cookie";

class UserTableAdd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      name_first: "",
      name_last: "",
      email: "",
      role: ""
    };
    this.createUser = this.createUser.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.updateEmail = this.updateEmail.bind(this);
  }

  toggleModal() {
    const { modalOpen } = this.state;
    this.setState({ modalOpen: !modalOpen });
  }

  updateNameFirst(e) {
    this.setState({ name_first: e.target.value });
  }
  updateNameLast(e) {
    this.setState({ name_last: e.target.value });
  }
  updateEmail(e) {
    this.setState({ email: e.target.value });
  }
  updateRole(e) {
    this.setState({ role: e.target.value });
  }

  createUser() {
    const { email, role, name_first, name_last } = this.state;
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");
    fetch((`/users/invite_user`), {
      method: 'POST',
      redirect: "manual",
      body: JSON.stringify({'email': email, 'role': role, 'name_first': name_first, 'name_last': name_last}),
      headers: {
        "X-CSRF-Token": token,
        "content-type": "application/json"
      }
    })
    .then(response => {
      console.log(response);
      return response.json();
    })
    .then(json => {
      if(json.error == null) {
        // console.log(json);
        location.reload();
      } else {
        console.log(json.error);
      }
    });
  }

  renderModal() {
    const { email, role, name_first, name_last } = this.state;
    return (
      <div style={{padding: "20px"}}>
        <div className="verdana-16-green">Add User</div>
        <br />
        <div className="form-field-group">
          <label>First Name</label>
          <input type="text" value={name_first} onChange={(e) => this.updateNameFirst(e)} />
        </div>
        <div className="form-field-group">
          <label>Last Name</label>
          <input type="text" value={name_last} onChange={(e) => this.updateNameLast(e)} />
        </div>
        <div className="form-field-group">
          <label>Email Address</label>
          <input type="text" value={email} onChange={(e) => this.updateEmail(e)} />
        </div>
        <div className="form-field-group">
          <label>Role</label>
          <select value={role} onChange={(e) => this.updateRole(e)}>
            <option value="jaguar">jaguar</option>
            <option value="gr_admin">gr_admin</option>
            <option value="user">user</option>
          </select>
        </div>
        <button className="default-button gillsans-14-white" onClick={this.createUser}>Save</button>
        <button className="default-button-cancel gillsans-14-black" onClick={this.toggleModal}>Cancel</button>
      </div>
    )
  }

  render() {
    const { modalOpen } = this.state;
    return (
      <>
        <div className="new-card-button gillsans-14-white">
          <a className="default-button" onClick={this.toggleModal} style={{cursor: "pointer"}}>New User</a>
        </div>
        <Modal
          className="general-modal add-tracking-modal"
          overlayClassName="modal-overlay"
          isOpen={modalOpen}
          onRequestClose={this.toggleModal}
          contentLabel=""
          style={{backgroundColor: "#00BCEB"}}
        >
          {this.renderModal()}
        </Modal>
      </>
    );
  }
}

export default UserTableAdd;
